import React from "react";
import { useAssetLibraryProvider, RecordingWidgetState } from "@/state/providers/AssetLibraryProvider";

interface AppBlurProps {
    children: React.ReactNode;
}

const AppBlur: React.FC<AppBlurProps> = ({ children }) => {
    // use the audio recording provider widget
    const {
        recordingWidgetControls: { recordingWidgetState },
    } = useAssetLibraryProvider();

    // determine if app should be blurred
    const isBlurred =
        recordingWidgetState === RecordingWidgetState.RECORDING ||
        recordingWidgetState === RecordingWidgetState.PAUSED ||
        recordingWidgetState === RecordingWidgetState.UPLOADING;

    return <div className={isBlurred ? "blur-sm pointer-events-none" : ""}>{children}</div>;
};

export default AppBlur;
